import React, { useState, useEffect } from "react";
import { Dropdown } from "semantic-ui-react";
import ReadAxios from "../axiosComponent/read";
import CreateAxios from "../axiosComponent/create";

const MyConsignor = ({
  field: { name },
  form: { setFieldValue },
  billingPartyId,
  billingPartyBranchId,
  setConsignorArray,
  consignorArray,
  ...props
}) => {
  const [consignor, setConsignor] = useState([]);
  const [isloading, setisloading] = useState(false);
  let [Txt, setTxt] =useState("");

  useEffect(() => {
    setisloading(true)

    const customerNo = localStorage.getItem('customerNumber')

    if (customerNo == 1183 && (billingPartyBranchId != null && billingPartyId != null && billingPartyBranchId != undefined && billingPartyId != undefined)) {

      ReadAxios({
        completeURL: `${process.env.REACT_APP_MASTER_API}/mappings/consignor_billing_party_branch?billingPartyId=${billingPartyId}&billingPartyBranchId=${billingPartyBranchId}`,
        // payload: { searchTerm: searchTerm },
      }).then((result) => {
        console.log("Result : ", result.data.resultSet);
        setConsignorArray(result.data.resultSet);
        setisloading(false);
      });
    } else if (props?.dontLoadInit == false) {
      if (props?.setData) {
        let temp = {};
        temp.ConsignorId = props?.setData?.id;
        temp.consignorName = props?.setData?.name;
        temp.consignorCode = props?.setData?.consignorCode;
        temp.raw = props.setData;

        setConsignor([temp])
      }
      setisloading(false);
    } else if (props.mode == "edit") {
      CreateAxios({
        completeURL: `${process.env.REACT_APP_MASTER_API}/consignorMaster`,
        // payload: { searchTerm: searchTerm },
      })
        .then((result) => {
          console.log("Result : ", result.data.resultSet);
          setConsignor(result.data.resultSet);
          setisloading(false);
        })
        .catch((error) => console.log(error));
    } else {
      setisloading(false);
    }

  }, []);

  let handleSearch = (e, data) => {
    if (localStorage.getItem('customerNumber') != 1183) {
      setisloading(true);
      let searchTerm = data.searchQuery;
      setTxt(data.searchQuery);
      setFieldValue(name, data.value);
      CreateAxios({
        completeURL: `${process.env.REACT_APP_MASTER_API}/consignorMaster`,
        payload: { searchTerm: searchTerm },
      })
        .then((result) => {
          console.log("Result : ", result.data.resultSet);
          setConsignor(result.data.resultSet);
          setisloading(false);
        })
        .catch((error) => console.log(error));
    }
  };

  let consignorNames = [];
  if (localStorage.getItem('customerNumber') == 1183 && consignorArray) {
    const filterdBillers = consignor.filter(obj => {return obj.consignorName.toLowerCase().startsWith(Txt)})
    console.log("filterdBillers",filterdBillers);
    filterdBillers.map((object, index) => {
      let temp = {};
      temp.key = object.ConsignorId;
      temp.text = `${object.consignorName} (${object.consignorCode})`;
      temp.value = object.consignorCode;
      temp.raw = object;
      return (consignorNames[index] = temp);
    });
  } else {
    if (consignor.length > 0) {
      const filterdBillers = consignor.filter(obj => {return obj.consignorName.toLowerCase().startsWith(Txt)})
      console.log("filterdBillers",filterdBillers);
      filterdBillers.map((object, index) => {
        let temp = {};
        temp.key = object.consignorId;
        temp.text = `${object.consignorName} (${object.consignorCode})`;
        temp.value = object.consignorCode;
        temp.raw = object;

        return (consignorNames[index] = temp);
      });
    }
  }

  let handleChange = (value, data) => {
    if (data.value) {
      setFieldValue(name, data.value);
      let op = data.options;
      op.map((item, o) => {
        if (item.raw.consignorCode == data.value) {
          setFieldValue(props.cname, item.raw.consignorName);
          console.log("GGGGGGGGGOTT ITTTTTTT")
          console.log(props?.consignorIDName)
          console.log(item)
          console.log(item.raw.consignorId)

          if (props?.consignorIDName) {
            setFieldValue(props.consignorIDName, item.raw.consignorId);
          }
        }
      });

      let filteredoptions = consignor.filter(item => {
        console.log("Match Array", item.consignorCode, data.value)
        return item.consignorCode == data.value
      },
      );

      let filteredOptions = consignorArray.filter(item => {
        console.log("Match Array", item.consignorCode, data.value)
        return item.consignorCode == data.value
      },
      );


      console.log("filteredoptions", filteredoptions, consignor, data.value, localStorage.getItem('customerNumber'));
      if (filteredoptions.length != 0) {
        setFieldValue(props.address, filteredoptions[0]?.address);
        setFieldValue(props.gst, filteredoptions[0]?.gstNumber);
      } else {
        setFieldValue(props.address, filteredOptions[0].address);
        setFieldValue(props.gst, filteredOptions[0].gstNumber);
      }
      /* let filteredoptions = consignor.filter(
        (item) => item.consignorCode == data.value
      ); */

    } else {
      setFieldValue(props.address, "");
      setFieldValue(props.gst, "");
      setFieldValue(props.cname, "");
    }
  };

  let OptionsList = consignorNames.sort((a, b) => a.text.toLowerCase() > b.text.toLowerCase() ? 1 : -1);

  return (
    <>

      {console.log("Consignor Array", consignorArray,)}
      <Dropdown
        selection
        search={localStorage.getItem('customerNumber') != 1183 ? true : false}
        clearable
        loading={isloading}
        style={{ width: "100%" }}
        onChange={handleChange}
        // search
        // onChange={(value, data) => setFieldValue(name, data.value)}
        options={OptionsList}
        onSearchChange={localStorage.getItem('customerNumber') != 1183 ? handleSearch : false}
        noResultsMessage="Search for Result"
        {...props}
      />
    </>
  );
};

export default MyConsignor;
